import React from 'react';
interface PricingSummaryProps {
  windowCount: number;
  totalBasePrice: number;
  totalAdderCost: number;
  grandTotal: number;
  productLine: string;
  discountPercent: number;
  onDiscountChange: (percent: number) => void;
  discountAmount: number;
  totalDue: number;
  isAtRedlineLimit: boolean;
}
function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}
export function PricingSummary({
  windowCount,
  totalBasePrice,
  totalAdderCost,
  grandTotal,
  productLine,
  discountPercent,
  onDiscountChange,
  discountAmount,
  totalDue,
  isAtRedlineLimit
}: PricingSummaryProps) {
  return <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-35">
      <div className="bg-[#2E5E3F] px-6 py-3" data-id="element-36">
        <h2 className="text-white font-semibold text-sm uppercase tracking-wide" data-id="element-37">
          Quote Summary
        </h2>
      </div>
      <div className="px-6 py-5" data-id="element-38">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-39">
          <div data-id="element-40">
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-1" data-id="element-41">
              Product Line
            </p>
            <p className="text-sm font-semibold text-gray-900" data-id="element-42">{productLine}</p>
          </div>
          <div data-id="element-43">
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-1" data-id="element-44">
              Windows
            </p>
            <p className="text-sm font-semibold text-gray-900" data-id="element-45">{windowCount}</p>
          </div>
          <div data-id="element-46">
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-1" data-id="element-47">
              Base Total
            </p>
            <p className="text-sm font-semibold text-gray-900 tabular-nums" data-id="element-48">
              {formatCurrency(totalBasePrice)}
            </p>
          </div>
          <div data-id="element-49">
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-1" data-id="element-50">
              Adders Total
            </p>
            <p className="text-sm font-semibold text-gray-900 tabular-nums" data-id="element-51">
              {formatCurrency(totalAdderCost)}
            </p>
          </div>
        </div>

        <div className="mt-5 pt-5 border-t border-gray-200 flex items-center justify-between" data-id="element-52">
          <span className="text-sm font-medium text-gray-600" data-id="element-53">Subtotal</span>
          <span className="text-lg font-semibold text-gray-900 tabular-nums" data-id="element-54">
            {formatCurrency(grandTotal)}
          </span>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-55">
          <div className="flex items-center justify-between gap-4" data-id="element-56">
            <div className="flex items-center gap-3" data-id="element-57">
              <label htmlFor="discount" className="text-sm font-medium text-gray-600 whitespace-nowrap" data-id="element-58">
                Discount
              </label>
              <div className="relative" data-id="element-59">
                <input id="discount" type="number" min={0} max={100} step={0.5} value={discountPercent || ''} onChange={e => {
                const val = Number(e.target.value);
                onDiscountChange(Math.min(Math.max(val, 0), 100));
              }} placeholder="0" className="w-20 px-2.5 py-1.5 text-sm text-right border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 tabular-nums pr-7" data-id="element-60" />
                <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400" data-id="element-61">
                  %
                </span>
              </div>
              {isAtRedlineLimit && <span className="text-xs text-gray-500" data-id="element-62">Discount capped</span>}
            </div>
            {discountAmount > 0 && <span className="text-sm font-medium text-red-600 tabular-nums" data-id="element-63">
                −{formatCurrency(discountAmount)}
              </span>}
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between" data-id="element-64">
          <span className="text-base font-semibold text-gray-800" data-id="element-65">
            Total Due
          </span>
          <span className="text-2xl font-bold text-[#2E5E3F] tabular-nums" data-id="element-66">
            {formatCurrency(totalDue)}
          </span>
        </div>
      </div>
    </div>;
}